import React from 'react'
import { PostElement } from 'lib/core/data/blog/post/types'
import { PostTile } from '../PostTile'
import { SectionTitle } from '../SectionTitle'
import { Toolbar } from '../Toolbar'
import { FeaturedGrid, NormalGrid } from './components/Styled'

interface Props {
  title?: string
  posts: Array<PostElement | undefined> // TODO: fix this type, should be "posts?: PostElement[]"
  isFeatured?: boolean
  isTag?: boolean
}

export const PostsGrid: React.FC<Props> = ({ title, posts, isFeatured = false, isTag = false }) => {
  const Container = isFeatured ? FeaturedGrid : NormalGrid

  return (
    <Container>
      <Toolbar />
      <div className='posts-grid'>
        {!isFeatured && (
          <SectionTitle
            title={title}
          />
        )}

        {posts?.map(post => {
          const {
            post_id: id,
            list_image: image,
            url_key: slug,
            title,
            short_content: shortContent
          } = post?.data ?? {}

          return (
            <div key={id}>
              <PostTile
                image={image}
                title={title}
                subtitle={shortContent}
                link={`/blog/post/${slug}`}
              />
            </div>
          )
        })}
      </div>
    </Container>
  )
}
